import { ConditionTypeEnum } from '.'

export interface ISingleSelectCondition {
  /**
   * The values needed to evaluate the condition
   */
  comparison: {
    /**
     * The expected condition value
     *
     * e.g. 'Pending'
     */
    expectedValue?: string | string[]
    /**
     * The operator to evaluate the condition, e.g. (is, is not, is any of, is none of, is empty, is not empty)
     */
    operator: SingleSelectOperatorEnum
  }
  /**
   * The field name associated with the condition, e.g. ('shipmentStatus')
   */
  conditionName: string
  /**
   * The type of condition
   */
  conditionType: ConditionTypeEnum.SingleSelect
}

export enum SingleSelectOperatorEnum {
  IS = 'is',
  IS_ANY_OF = 'is any of',
  IS_EMPTY = 'is empty',
  IS_NONE_OF = 'is none of',
  IS_NOT = 'is not',
  IS_NOT_EMPTY = 'is not empty'
}
